import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import classes from "../styles.module.scss";
import HumanResourcesTab from "./screening-tabs/human-resources-tab.component";
import LandFundTab from "./screening-tabs/land-fund-tab.component";
import AgricultureTab from "./screening-tabs/agriculture-tab.component";
import SmbDevelopmentTab from "./screening-tabs/smb-development-tab.component";
import SwotAnalysisTab from "./screening-tabs/swot-analysis-tab.component";
import { useKato } from "../../../contexts/kato.context";
import { useUser } from "../../../contexts/user.context";
import { downloadScreeningReport } from "../../../requests/screening.request";

export const tabs = [
  "human-resources",
  "land-fund",
  "agriculture",
  "smb-development",
  "swot-analysis",
];

const baseClass = "screening";
const translationKey = "screening";

const Screening = () => {
  const { t } = useTranslation();
  const { isModulePresent, modules } = useUser();
  const [filteredTabs, setFilteredTabs] = useState(
    tabs.filter((tab) => isModulePresent(tab))
  );
  const [activeTab, setActiveTab] = useState(filteredTabs[0]);
  const { updateScreeningInfo } = useKato();

  const handleDownloadReport = () => {
    downloadScreeningReport();
  };

  useEffect(() => {
    updateScreeningInfo();
  }, []);

  useEffect(() => {
    if (!activeTab) {
      setActiveTab(filteredTabs[0]);
    }
  }, [filteredTabs]);

  useEffect(() => {
    const filtered = tabs.filter((tab) => isModulePresent(tab));
    setFilteredTabs(filtered);
    if (!filtered.includes(activeTab)) {
      setActiveTab(filtered[0]);
    }
  }, [modules]);

  return (
    <div className={classes[baseClass]}>
      <div className={classes[`${baseClass}__tabs`]}>
        <div>
          {filteredTabs.map((tab) => (
            <button
              key={tab}
              className={`${classes[`${baseClass}__tab`]} ${
                activeTab === tab ? classes["active"] : ""
              }`}
              onClick={() => setActiveTab(tab)}
            >
              {t(`${translationKey}.tabs.${tab}`)}
            </button>
          ))}
        </div>
        <button
          onClick={handleDownloadReport}
          className={classes[`${baseClass}__download`]}
        >
          {t(`${translationKey}.download`)}
        </button>
      </div>
      <div className={classes[`${baseClass}__content`]}>
        {activeTab === "human-resources" && isModulePresent(activeTab) && (
          <HumanResourcesTab />
        )}
        {activeTab === "land-fund" && isModulePresent(activeTab) && (
          <LandFundTab />
        )}
        {activeTab === "agriculture" && isModulePresent(activeTab) && (
          <AgricultureTab />
        )}
        {activeTab === "smb-development" && isModulePresent(activeTab) && (
          <SmbDevelopmentTab />
        )}
        {activeTab === "swot-analysis" && isModulePresent(activeTab) && (
          <SwotAnalysisTab />
        )}
      </div>
    </div>
  );
};

export default Screening;
